import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
// component
import Logo from "../logo/Logo";

// utils
import { isEmpty } from "../../utils";

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

// const LightTooltip = styled(({ className, ...props }) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: "#fff",
//     color: "rgba(0, 0, 0, 0.87)",
//     boxShadow: "0 1px 1px grey",
//     fontSize: 11,
//   },
// }));

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  "&.MuiPaper-root": {
    boxShadow: "none",
  },
}));

const StyledToolBar = styled(Toolbar)(({ theme }) => ({
  "&.MuiToolbar-root": {
    padding: "auto 24px",
    backgroundColor: "#fff",
  },
}));

//
const HeaderRwd = ({ desktop, mobile }) => {
  // style
  const classes = useStyles();
  // props
  const { logo } = desktop;

  // local state

  const desktopLeftEles = desktop.left.filter((item) => item.show);
  const desktopRightEles = desktop.right.filter((item) => item.show);

  return (
    <Box sx={{ flexGrow: 1, zIndex: 1250 }}>
      <StyledAppBar position="static" color="default">
        <StyledToolBar>
          <Box mr={2}>{logo}</Box>
          {desktopLeftEles.length === 0 && <Box sx={{ flexGrow: 1 }} />}
          {desktopLeftEles.map(
            (item, idx) =>
              (idx < desktopLeftEles.length - 1 && (
                <Box key={idx.toString()} sx={{ mr: 2 }}>
                  {item.ele}
                </Box>
              )) || (
                <Box key={idx.toString()} sx={{ flexGrow: 1 }}>
                  {item.ele}
                </Box>
              )
          )}
          {desktopRightEles.map((item, idx) => (
            <Box key={idx.toString()} sx={{ ml: 2 }}>
              {item.ele}
            </Box>
          ))}
        </StyledToolBar>
      </StyledAppBar>
    </Box>
  );
};

HeaderRwd.propTypes = {
  desktop: PropTypes.objectOf(PropTypes.any),
  mobile: PropTypes.objectOf(PropTypes.any),
};

HeaderRwd.defaultProps = {
  desktop: {},
  mobile: {},
};

export default HeaderRwd;
